'use strict';

/* exported
 menuPromoCodes
 */
function menuPromoCodes($scope, $rootScope, $location) {
  $scope.filters = {
    status: $location.search().status || 'active',
    creator: $location.search().creator,
    code: $location.search().code,
    description: $location.search().description,
    campaignType: $location.search().campaignType,
    team: $location.search().team
  };

  $scope.filterByStatus = function() {
    if ($scope.filters.status === '') {
      $scope.filters.status = undefined;
    }

    $rootScope.$broadcast('filters.status', $scope.filters.status);
    updateUrlParams();
  };

  $scope.filterByType = function() {
    if ($scope.filters.campaignType === '') {
      $scope.filters.campaignType = undefined;
    }

    $rootScope.$broadcast('filters.campaignType', $scope.filters.campaignType);
    updateUrlParams();
  };

  $scope.filterByTeam = function() {
    if ($scope.filters.team === '') {
      $scope.filters.team = undefined;
    }

    $rootScope.$broadcast('filters.team', $scope.filters.team);
    updateUrlParams();
  };

  $scope.filterByCreator = function() {
    if ($scope.filters.creator === '') {
      $scope.filters.creator = undefined;
    }

    $rootScope.$broadcast('filters.creator', $scope.filters.creator);
    updateUrlParams();
  };

  $scope.filterByPrefix = function() {
    if ($scope.filters.prefix === '') {
      $scope.filters.prefix = undefined;
    }

    $rootScope.$broadcast('filters.prefix', $scope.filters.prefix);
    updateUrlParams();
  };

  $scope.filterByDescription = function() {
    if ($scope.filters.description === '') {
      $scope.filters.description = undefined;
    }

    $rootScope.$broadcast('filters.description', $scope.filters.description);
    updateUrlParams();
  };

  function updateUrlParams() {
    const search = $location.search();
    Object.assign(search, $scope.filters);
    $location.search(search);
  }
}

'use strict';

/* exported
 promoCodeEditMenuSerialCtrl
 */
function promoCodeEditMenuSerialCtrl($rootScope, $scope, $state, $stateParams) {

  $scope.$stateParams = $stateParams;

  const currentState = $state.current.name;
  if (currentState.includes('Single')) {
    $scope.campaignType = 'single';
  } else if (currentState.includes('Serial')) {
    $scope.campaignType = 'serial';
  } else {
    $scope.campaignType = 'single';
  }
  
  $scope.setActiveTab = function(campaignType) {
    if (campaignType === $scope.campaignType) {
      return;
    }


    if (campaignType === 'single') {
      $state.go('root.editPromocode', { campaignId: null });
    } else if (campaignType === 'serial') {
      $state.go('root.editPromocodeSerial', { campaignId: null });
    }
  };
}

'use strict';

/* exported
 generateSerialCode,
 promoCodeEditSerialCtrl
 */
function generateSerialCode(prefix) {
  if (prefix === undefined) {
    prefix = '';
  }
  const mask = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const codeLength = 6;
  let result = '';

  for (let i = 0; i < codeLength; i++) {
    result += mask[Math.floor(Math.random() * mask.length)];
  }

  return prefix ? prefix + '-' + result : result;
}
function promoCodeEditSerialCtrl($rootScope, $scope, campaignRes, Restangular, generateCode, $localStorage, $uibModal, $state) {
  const campaign = campaignRes.campaign;
  const codes = campaignRes.codes;
  const CODES_PAGE_SIZE = 50;

  const defaultCampaign = {
    activated: true,
    type: 'amount',
    campaignType: campaignRes.campaignType,
    createdBy: {
      name: $localStorage.session.user.displayName,
      email: $localStorage.session.user.email,
    },
    prefix: '',
    serialCodesPreviews: [],
    audienceLimitation: {
      countries: [],
      routes: [],
      transportTypes: [],
      suppliers: [],
      partners: [],
      operatingSystems: []
    },
  };

  if (campaign && campaign._id) {
    $scope.campaign = Restangular.restangularizeElement(null, campaign, 'promocodes');
    $scope.campaign.serialCodes = codes.data;
    $scope.allCodes = codes.data || [];
    $scope.codesTotal = codes.total || 0;
  } else if (campaign && campaign.campaignType) {
    $scope.campaign = Object.assign({}, defaultCampaign, { campaignType: campaign.campaignType });
  } else {
    $scope.campaign = defaultCampaign;
  }

  if (!$scope.campaign.prefix) {
    $scope.campaign.prefix = '';
  }

  if (!$scope.campaign.serialCodesPreviews) {
    $scope.campaign.serialCodesPreviews = [];
  }

  if (!$scope.campaign.audienceLimitation) {
    $scope.campaign.audienceLimitation = {
      countries: [],
      routes: [],
      transportTypes: [],
      suppliers: [],
      partners: [],
      operatingSystems: []
    };
  }

  const audienceLimitationProperties = ['countries', 'routes', 'transportTypes', 'suppliers', 'partners', 'operatingSystems'];
  audienceLimitationProperties.forEach(function(prop) {
    if (!$scope.campaign.audienceLimitation[prop]) {
      $scope.campaign.audienceLimitation[prop] = [];
    }
  });

  $scope.formatAudienceLimitation = function(limitation) {
    if (!limitation) return '—';

    var labels = {
      routes: '🗺️ Routes',
      countries: '🌍 Countries',
      transportTypes: '🚌 Transport',
      suppliers: '🏢 Suppliers',
      partners: '🤝 Partners',
      operatingSystems: '📱 OS',
    };

    var parts = [];
    Object.keys(labels).forEach(function(key) {
      var items = limitation[key];
      if (!items || !items.length) return;
      var names = items.map(function(item) {
        return item.name && item.name.common ? item.name.common : item.name || item._id;
      });
      parts.push(labels[key] + ': ' + names.join(', '));
    });

    return parts.length ? parts.join(' | ') : '—';
  };

  $scope.saveSuccess = false;

  $scope.teams = [
    { value: 'marketing', label: 'Marketing' },
    { value: 'support', label: 'Support' }
  ];

  $scope.expirationType = campaign && campaign.expiredAt ? 'date' : 'number';
  $scope.minimumPurchaseActivated = campaign && campaign.minimumPurchase > 0;
  $scope.unlimited = ($scope.campaign.campaignType === 'serial' && !$scope.campaign.perUserLimit) || 
                     ($scope.campaign.campaignType === 'single' && !$scope.campaign.limit);

  $scope.$watch('unlimited', function(newValue) {
    if (newValue) {
      $scope.campaign.limit = null;
      $scope.campaign.perUserLimit = null;
    }
  });

  $scope.campaign.expiredAt = campaign && campaign.expiredAt ? new Date(campaign.expiredAt) : null;
  $scope.isNewCampaign = !campaign || !campaign._id;

  if ($scope.campaign.expiredAt) {
    const originalDate = new Date($scope.campaign.expiredAt);
    $scope.campaign.expiredAt = new Date(
      originalDate.getUTCFullYear(),
      originalDate.getUTCMonth(),
      originalDate.getUTCDate()
    );
  }

  $scope.calculatedExpirationDate = null;

  $scope.$watch('[expirationType, campaign.expiredIn]', function(newValues) {
    var expirationType = newValues[0];
    var expiredIn = newValues[1];
    if (expirationType === 'number' && expiredIn && expiredIn > 0) {
      const currentDate = new Date();
      const expirationDate = new Date(currentDate.getTime() + (expiredIn * 24 * 60 * 60 * 1000));
      $scope.calculatedExpirationDate = expirationDate;
    } else {
      $scope.calculatedExpirationDate = null;
    }
  }, true);

  $scope.generateSerialCodesPreviews = function() {
    if (!$scope.campaign.prefix || !$scope.campaign.prefix.length) {
      return;
    }

    $scope.campaign.serialCodesPreviews = [];
    const countOfPreviews = 2;
    for (let i = 0; i < countOfPreviews; i++) {
      const prefix = generateSerialCode($scope.campaign.prefix);
      $scope.campaign.serialCodesPreviews.push(prefix);
    }
  };

  if ($scope.campaign.campaignType === 'serial' && $scope.campaign.prefix) {
    $scope.generateSerialCodesPreviews();
  }

  $scope.generateCode = function (isSerial) {
    if (isSerial === undefined) {
      isSerial = false;
    }
    $scope.campaign.prefix = generateCode(isSerial).toUpperCase();
    
    if ($scope.campaign.campaignType === 'serial') {
      $scope.generateSerialCodesPreviews();
    }
  };

  $scope.onPrefixChange = function() {
    $scope.campaign.prefix = $scope.campaign.prefix.toUpperCase();
    $scope.generateSerialCodesPreviews();
  };

  $scope.exportSerialCodes = function() {
    const fileContent = $scope.campaign.serialCodes.map(function(code) { 
      return (code.code || code).toUpperCase(); 
    }).join('\n');
    const blob = new Blob([fileContent], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'serial-codes-' + $scope.campaign.prefix + '.xls';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  $scope.save = function() {
    $scope.saveSuccess = false;
    $scope.campaignForm.team.$setTouched();
    $scope.campaignForm.value.$setTouched();

    if ($scope.minimumPurchaseActivated) {
      $scope.campaignForm.minimumPurchase.$setTouched();
    }

    if (!$scope.campaignForm.unlimited.$modelValue) {
      if ($scope.campaign.campaignType === 'single') {
        $scope.campaignForm.limit.$setTouched();
      }
      $scope.campaignForm.perUserLimit.$setTouched();
    }

    if ($scope.campaign.campaignType === 'single' && $scope.campaignForm.prefix.$touched) {
      $scope.campaignForm.prefix.$invalid = !new RegExp(/^([\w\d]){6,12}$/i).test($scope.campaignForm.prefix.$modelValue);
      if ($scope.campaignForm.prefix.$invalid) {
        return;
      }
    }

    if ($scope.campaignForm.$invalid) {
      $scope.campaignForm.prefix.$setTouched();
      $scope.campaignForm.expiredAt.$setTouched();
      $scope.campaignForm.expiredIn.$setTouched();
      $scope.campaignForm.value.$setTouched();
      $scope.campaignForm.type.$setTouched();
      return;
    }

    var campaignToSave = Object.assign({}, $scope.campaign);

    if ($scope.expirationType === 'date') {
      campaignToSave.expiredIn = null;
      if (campaignToSave.expiredAt) {
        const selectedDate = new Date(campaignToSave.expiredAt);

        campaignToSave.expiredAt = new Date(Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
          23, 59, 59, 999
        ));
      }
    } else if ($scope.expirationType === 'number') {
      campaignToSave.expiredAt = null;
    }

    if (!$scope.minimumPurchaseActivated) {
      campaignToSave.minimumPurchase = null;
    }

    var promise = $scope.campaign._id ? 
      Restangular.restangularizeElement(null, campaignToSave, 'promocodes').put() : 
      Restangular.all('promocodes').post(campaignToSave);

    promise
      .then(function(res) {
        $scope.$emit('notify', {type: 'success', title: 'Create campaign', message: $scope.isNewCampaign ? 'Campaign created successfully' : 'Campaign updated successfully'});
        
        if ($scope.campaign.campaignType === 'serial') {
          const campaignObj = {
            campaignType: 'serial',
            serialCodes: res.codes,
            prefix: res.campaign && res.campaign.prefix
          };

          $scope.campaign = Object.assign(
            {},
            $scope.campaign,
            campaignObj,
            res.campaign || {}
          );

          if (res.codes && res.codes.length) {
            $scope.allCodes = res.codes;
            $scope.codesTotal = res.codes.length;
            $scope.codesCurrentPage = 1;
            updateCodesPage();
          }
        }

        $scope.saveSuccess = true;

        if ($scope.expirationType === 'number' && $scope.campaign.expiredIn) {
          const currentDate = new Date();
          const expirationDate = new Date(currentDate.getTime() + ($scope.campaign.expiredIn * 24 * 60 * 60 * 1000));
          $scope.calculatedExpirationDate = expirationDate;
        } else {
          $scope.calculatedExpirationDate = null;
        }

        if ($scope.isNewCampaign && res.campaign._id) {
          const stateName = $scope.campaign.campaignType === 'serial' 
            ? 'root.editPromocodeSerial' 
            : 'root.editPromocode';
          
          $state.go(stateName, { campaignId: res.campaign._id });
        }
      })
      .catch(function(err) {
        $scope.$emit('notify', {type: 'error', title: 'Create campaign', message: err.data.message});
        $scope.globalError = err.data.message;
        $scope.saveSuccess = false;
      });
  };

  // Codes table — client-side pagination
  $scope.codesCurrentPage = 1;
  $scope.codesPageSize = CODES_PAGE_SIZE;

  function updateCodesPage() {
    var all = $scope.allCodes || [];
    all.sort(function(a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    $scope.filteredCodesTotal = all.length;
    var start = ($scope.codesCurrentPage - 1) * $scope.codesPageSize;
    $scope.codesPage = all.slice(start, start + $scope.codesPageSize);
  }

  $scope.onCodesPageChanged = function() {
    updateCodesPage();
  };

  updateCodesPage();

  $scope.appendingCode = false;

  $scope.appendCode = function() {
    var input = prompt('How many codes would you like to create for campaign ' + $scope.campaign.prefix + '?', '1');
    if (input === null) {
      return;
    }

    var count = parseInt(input, 10);
    if (isNaN(count) || count < 1) {
      alert('Please enter a valid number greater than 0.');
      return;
    }

    $scope.appendingCode = true;

    var promocodes = [];
    for (var i = 0; i < count; i++) {
      promocodes.push({ overrides: {} });
    }

    Restangular.all('promocodes/' + $scope.campaign._id + '/codes/append')
      .post({ promocodes: promocodes })
      .then(function(res) {
        $scope.$emit('notify', { type: 'success', title: 'Add Code', message: 'Code added successfully' });

        if (res.codes && res.codes.length) {
          res.codes.forEach(function(code) {
            $scope.allCodes.push({ code: code, activated: true, usagesNumber: 0, limit: 1, createdAt: new Date() });
          });
          $scope.campaign.serialCodes = $scope.allCodes;
          $scope.codesTotal = $scope.allCodes.length;
          updateCodesPage();
        }

        if (res.campaign && res.campaign.serialCodesCount != null) {
          $scope.campaign.serialCodesCount = res.campaign.serialCodesCount;
        }
      })
      .catch(function(err) {
        var message = (err.data && err.data.message) || 'Failed to add code';
        $scope.$emit('notify', { type: 'error', title: 'Add Code', message: message });
      })
      .finally(function() {
        $scope.appendingCode = false;
      });
  };

  $scope.openAudienceLimitationsModal = function() {
    const modalInstance = $uibModal.open({
      templateUrl: 'views/promocodes/audience-limitations.html',
      controller: 'AudienceLimitationsCtrl',
      resolve: {
        supplierApiService: ['SupplierApiService', function(SupplierApiService) {
          return SupplierApiService;
        }],
        RoutesRestangular: ['RoutesRestangular', function(RoutesRestangular) {
          return RoutesRestangular;
        }],
        initialLimitation: function() {
          return $scope.campaign.audienceLimitation;
        }
      }
    });

    modalInstance.result.then(function(updatedLimitation) {
      $scope.campaign.audienceLimitation = updatedLimitation;
      if ($scope.campaignForm) {
        $scope.campaignForm.$setDirty();
      }
    });
  };
}

'use strict';

/* exported
 promoCodesCtrl
 */
function promoCodesCtrl($scope, Restangular, $uibModal, $state, $location) {
  const defaultPageLimit = 50;
  // On first load uib-pagination triggers page change, so we need to prevent it
  let isInitialLoad = true;

  $scope.pageLimit = defaultPageLimit;
  $scope.currentPage = $location.search().page ? $location.search().page : 1;

  initializeSorting();
  
  $scope.filters = {
    activated: getActivatedFilterValue($location.search().status),
    prefix: $location.search().prefix,
    description: $location.search().description,
    creator: $location.search().creator,
    campaignType: $location.search().campaignType,
    sort: $scope.sortColumn + ':' + ($scope.sortOrder === 'asc' ? '1' : '-1')
  };

  fetchData(false);

  $scope.sortBy = function(column) {
    if (column === $scope.sortColumn) {
      $scope.sortOrder = $scope.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      $scope.sortColumn = column;
      $scope.sortOrder = 'asc';
    }
    

    const sortValue = $scope.sortColumn + ':' + ($scope.sortOrder === 'asc' ? '1' : '-1');
    $scope.filters.sort = sortValue;

    $location.search('sort', sortValue);

    fetchData(true);
  };

  $scope.resetToDefaultSorting = function() {

    $location.search('sort', null);
    

    initializeSorting();
    

    $scope.filters.sort = $scope.sortColumn + ':' + ($scope.sortOrder === 'asc' ? '1' : '-1');
    fetchData(true);
  };

  function initializeSorting() {
    let defaultSortColumn = 'expiredAt';
    let defaultSortOrder = 'desc';

    const urlSort = $location.search().sort;
    if (urlSort) {
      const sortParts = urlSort.split(':');
      if (sortParts.length === 2) {
        defaultSortColumn = sortParts[0];
        defaultSortOrder = sortParts[1] === '1' ? 'asc' : 'desc';
      }
    }
    
    $scope.sortColumn = defaultSortColumn;
    $scope.sortOrder = defaultSortOrder;
  }

  $scope.pageChanged = function() {
    if (isInitialLoad) {
      return;
    }

    $location.search('page', $scope.currentPage);
    fetchData(false);
  };

  $scope.$on('filters.status', function(event, data) {
    if (data === 'active') {
      $scope.filters.activated = true;
    } else if (data === 'inactive') {
      $scope.filters.activated = false;
    } else {
      $scope.filters.activated = null;
    }

    fetchData(true);
  });

  $scope.$on('filters.prefix', function(event, data) {
    $scope.filters.prefix = data;
    fetchData(true);
  });

  $scope.$on('filters.description', function(event, data) {
    $scope.filters.description = data;
    fetchData(true);
  });

  $scope.$on('filters.creator', function(event, data) {
    $scope.filters.creator = data;
    fetchData(true);
  });

  $scope.$on('filters.campaignType', function(event, data) {
    $scope.filters.campaignType = data;
    fetchData(true);
  });

  $scope.$on('filters.team', function(event, data) {
    $scope.filters.team = data;
    fetchData(true);
  });

  $scope.$on('filters.sort', function(event, data) {
    $scope.filters.sort = data;
    fetchData(true);
  });

  function fetchData(resetPagination) {
    const offset = ($scope.currentPage - 1) * $scope.pageLimit;
    const filters = Object.assign({}, $scope.filters, {
      offset, 
      limit: $scope.pageLimit,
      sort: $scope.filters.sort,
    });

    Restangular.all('promocodes').getList(filters).then(function(campaigns) {
      if (resetPagination) {
        $scope.currentPage = 1;
        $location.search('page', undefined);
      }

      $scope.campaigns = mapCampaignsToModels(campaigns);
      $scope.total = campaigns.meta.total;
      isInitialLoad = false;
    });
  }

  function mapCampaignsToModels(campaigns) {
    return campaigns.map(function(campaign) {
      return Object.assign({}, campaign, {
        campaignDisplayName: campaign.prefix,
        tooltipDescription: getTooltipDescription(campaign),
        minimumValue: campaign.minimumPurchase ? campaign.minimumPurchase : '-',
        teamDisplay: campaign.team ? campaign.team.charAt(0).toUpperCase() + campaign.team.slice(1) : '-'
      });
    });
  }

  function getTooltipDescription(campaign) {
    if (!campaign.description) {
      return null;
    }

    if (campaign.description.length < 100) {
      return campaign.description;
    }

    return campaign.description.substring(0, 100) + '...';
  }

  function getActivatedFilterValue(status) {
    if (status === 'active') {
      return true;
    } else if (status === 'inactive') {
      return false;
    } else {
      // Default value
      return true;
    }
  };
}

'use strict';

/* exported
 numberWithCommasDirective
 */
// Directive for formatting numbers with commas
function numberWithCommasDirective() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {
      
      function formatWithCommas(value) {
        if (!value) return '';
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      
      function removeCommas(value) {
        if (!value) return null;
        const cleaned = value.replace(/[^\d]/g, '');
        return cleaned ? parseInt(cleaned, 10) : null;
      }
      
      // Format for display
      ngModelCtrl.$formatters.push(function(value) {
        return formatWithCommas(value);
      });
      
      // Parse for model
      ngModelCtrl.$parsers.push(function(value) {
        const numericValue = removeCommas(value);
        const formattedValue = formatWithCommas(numericValue);
        
        if (formattedValue !== value) {
          ngModelCtrl.$setViewValue(formattedValue);
          ngModelCtrl.$render();
        }
        
        return numericValue;
      });
      
      // Handle input events for real-time formatting
      element.on('input', function() {
        const value = element.val();
        const numericValue = removeCommas(value);
        const formattedValue = formatWithCommas(numericValue);
        
        if (formattedValue !== value) {
          const cursorPos = element[0].selectionStart;
          const oldLength = value.length;
          
          element.val(formattedValue);
          ngModelCtrl.$setViewValue(formattedValue);
          
          // Adjust cursor position after formatting
          const newLength = formattedValue.length;
          const newCursorPos = cursorPos + (newLength - oldLength);
          element[0].setSelectionRange(newCursorPos, newCursorPos);
        }
      });
    }
  };
} 
'use strict';

/* exported
 audienceLimitationsCtrl
 */
function audienceLimitationsCtrl($scope, $uibModalInstance, Restangular, countries, supplierApiService, RoutesRestangular, initialLimitation, UsersRestangular) {
  $scope.countries = countries;
  $scope.supplierApiService = supplierApiService;


  $scope.transportTypes = [
    { id: 'bus', name: 'Bus' },
    { id: 'minivan', name: 'Minivan' },
    { id: 'train', name: 'Train' },
    { id: 'ferry', name: 'Ferry' },
    { id: 'car', name: 'Car' },
    { id: 'flight', name: 'Flight' },
    { id: 'cable_car', name: 'Cable Car' },
    { id: 'bus-ferry', name: 'Bus + Ferry' },
    { id: 'van-ferry', name: 'Van + Ferry' },
    { id: 'car-ferry', name: 'Car + Ferry' }
  ];

  $scope.operatingSystems = [
    { id: 'ios', name: 'iOS' },
    { id: 'android', name: 'Android' },
    { id: 'web', name: 'Web' }
  ];

  $scope.routes = [];
  $scope.partners = [];

  $scope.selectedLimitations = initialLimitation || {
    countries: [],
    routes: [],
    transportTypes: [],
    suppliers: [],
    partners: [],
    operatingSystems: []
  };

  Promise.all([
    fetchRoutes(),
    fetchPartners(),
    fetchSuppliers()
  ]).then(() => {
    initializeSelections();
  });

  function initializeSelections() {
    if (!initialLimitation) {
      return;
    }

    if (initialLimitation.countries && initialLimitation.countries.length > 0) {
      $scope.selectedLimitations.countries = initialLimitation.countries;
    }

    if (initialLimitation.routes && initialLimitation.routes.length > 0) {
      $scope.selectedLimitations.routes = initialLimitation.routes;
    }

    if (initialLimitation.transportTypes && initialLimitation.transportTypes.length > 0) {
      $scope.selectedLimitations.transportTypes = initialLimitation.transportTypes.map(type => {
        const match = $scope.transportTypes.find(t => t.id === type.id);
        return match || type;
      });
    }

    if (initialLimitation.suppliers && initialLimitation.suppliers.length > 0) {
      $scope.selectedLimitations.suppliers = initialLimitation.suppliers;
    }

    if (initialLimitation.partners && initialLimitation.partners.length > 0) {
      $scope.selectedLimitations.partners = initialLimitation.partners;
    }

    if (initialLimitation.operatingSystems && initialLimitation.operatingSystems.length > 0) {
      $scope.selectedLimitations.operatingSystems = initialLimitation.operatingSystems.map(os => {
        const match = $scope.operatingSystems.find(o => o.id === os.id);
        return match || os;
      });
    }

    $scope.$apply();
  }


  $scope.refreshRoutesList = function (search) {
    if (!search) {
      return;
    }

    fetchRoutes(search);
  };

  $scope.refreshPartnersList = function (search) {
    if (!search) {
      return;
    }

    fetchPartners(search);
  };

  $scope.refreshSuppliersList = function (search) {
    if (!search) {
      return;
    }

    fetchSuppliers(search);
  };

  $scope.save = function () {
    const processedLimitations = {
      countries: $scope.selectedLimitations.countries.map(country => ({
        id: country._id || country.id,
        name: country.name,
        slug: country.slug,
        iso2: country.iso2,
      })),

      routes: $scope.selectedLimitations.routes.map(route => ({
        id: route._id || route.id,
        slug: route.slug,
        name: route.name,
      })),

      transportTypes: $scope.selectedLimitations.transportTypes.map(type => type),

      suppliers: $scope.selectedLimitations.suppliers.map(supplier => ({
        id: supplier._id || supplier.id,
        name: supplier.name,
        slug: supplier.slug
      })),

      partners: $scope.selectedLimitations.partners.map(partner => ({
        id: partner._id || partner.id,
        name: partner.name,
        slug: partner.slug
      })),

      operatingSystems: $scope.selectedLimitations.operatingSystems
    };

    $uibModalInstance.close(processedLimitations);
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  function fetchSuppliers(search) {

    return UsersRestangular
      .all('companies')
      .getList({ search: search })
      .then(function (companies) {
        $scope.supplierApiService.supplierList = companies;
        if (initialLimitation && initialLimitation.suppliers && initialLimitation.suppliers.length > 0) {
          initialLimitation.suppliers.forEach(function (selectedSupplier) {
            const exists = suppliers.some(s =>
              (s._id && selectedSupplier._id && s._id === selectedSupplier._id) ||
              (s.id && selectedSupplier.id && s.id === selectedSupplier.id)
            );

            if (!exists) {

              $scope.supplierApiService.supplierList.push(selectedSupplier);
            }
          });
        }
      });
  }

  function fetchRoutes(search) {
    const query = search ? { slug: search, limit: 10 } : { limit: 10, offset: 0 };
    return RoutesRestangular
      .all('/v1/routes')
      .getList(query)
      .then(function (routes) {
        const mappedRoutes = routes.map(route => ({
          id: route._id,
          name: route.slug,
        }));

        if (initialLimitation && initialLimitation.routes && initialLimitation.routes.length > 0) {
          initialLimitation.routes.forEach(function (selectedRoute) {
            const exists = mappedRoutes.some(r => r.id === selectedRoute.id);

            if (!exists) {
              mappedRoutes.push(selectedRoute);
            }
          });
        }

        $scope.routes = mappedRoutes;
      });
  }

  function fetchPartners(search) {

    const query = search ? { search: search, excludeRestrictedChannels: true } : { excludeRestrictedChannels: true };
    return Restangular.all('v2/channels').getList(query)
      .then(function (channels) {

        if (initialLimitation && initialLimitation.partners && initialLimitation.partners.length > 0) {
          initialLimitation.partners.forEach(function (selectedPartner) {
            const exists = channels.some(c =>
              (c._id && selectedPartner._id && c._id === selectedPartner._id) ||
              (c.id && selectedPartner.id && c.id === selectedPartner.id)
            );

            if (!exists) {
              channels.push(selectedPartner);
            }
          });
        }

        $scope.partners = channels;
      });
  }
}

'use strict';


/* exported
 generateCode
 */

function generateCode(isSerial = false){
    var length = isSerial ? 4 + Math.random() * 4 : 6 + Math.random() * 6;
    var mask = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += mask[Math.floor(Math.random() * mask.length)];
    }
    return result;
}

